import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import PageOne from './components/PageOne';
import PageTwo from './components/PageTwo';
import PageThree from './components/PageThree';
import PageFour from './components/PageFour';
import PageFive from './components/PageFive';
import PageSix from './components/PageSix';
import { Energy, Immunity, Focus, Face, Eye, Smile, Gut, Fruit, Shoe } from './icons/Icons';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import queryString from 'query-string';

const apiQuizKids = 'https://app.get-nourished.com/api/klaviyo/quiz-kids--uk';

const KidsQuiz = () => {
  const [pageIndex, setPageIndex] = useState(1);
  const [kidsName, setKidsName] = useState('');
  const [gender, setGender] = useState('');
  const [age, setAge] = useState('');
  const [suitableAge, setSuitableAge] = useState(true);
  const [weightingAnswers, setWeightingsAnswers] = useState([]);
  const [activeGoalsAnswer, setActiveGoalsAnswer] = useState([]);
  const [specificDiet, setSpecificDiet] = useState('');
  const [dietAnswersIndex, setDietAnswersIndex] = useState([]);
  const [hungryBetweenMeals, setHungryBetweenMeals] = useState('');
  const [processedFoodAnswer, setProcessedFoodAnswer] = useState('');
  const [fruitVegAnswer, setFruitVegAnswer] = useState('');
  const [glassesAnswer, setGlassesAnswer] = useState('');
  const [energySliderValue, setEnergySliderValue] = useState(50);
  const [activitySliderValue, setActivitySliderValue] = useState(50);
  const [sleepSliderValue, setSleepSliderValue] = useState(50);
  const [screenSliderValue, setScreenSliderValue] = useState(50);
  const [attentionSliderValue, setAttentionSliderValue] = useState(50);
  const [conditionsAnswerIndex, setConditionsAnswerIndex] = useState([]);
  const [flavour, setFlavour] = useState('');
  const [coating, setCoating] = useState('');
  const [parentsName, setParentsName] = useState('');
  const [email, setEmail] = useState('');
  const [consent, setConsent] = useState(false);
  const [questionGA, setQuestionGA] = useState('');
  const [quizID, setQuizID] = useState('');

  useEffect(() => {
    const currentUrl = window.location.href;
    const activeStepUrl = queryString.stringifyUrl({ url: currentUrl, query: { page: `${pageIndex}` } });

    if (typeof ga !== 'undefined') {
      history.replaceState({}, null, activeStepUrl);
      ga('send', 'pageview', location.href);
    }
  }, [pageIndex]);

  const updateQuestionUrl = (value) => {
    const currentUrl = window.location.href;
    const activeStepUrl = queryString.stringifyUrl({ url: currentUrl, query: { page: `${pageIndex}-${value}` } });

    if (value !== questionGA && typeof ga !== 'undefined') {
      history.replaceState({}, null, activeStepUrl);
      ga('send', 'pageview', location.href);
    }
    setQuestionGA(value);
  }

  const genderAnswers = [
    {
      "name": "gender",
      "label": "Male",
      "value": "male"
    },
    {
      "name": "gender",
      "label": "Female",
      "value": "female"
    },
    {
      "name": "gender",
      "label": "Prefer not to say",
      "value": "opt-out"
    }
  ];

  const goalsQuestion = {
    "question": `What would you say is the number one goal for ${kidsName}'s health for the next 3 months?`,
    "answers": [
      {
        "label": 'More energy',
        "icon": 'energy',
        "questionId": 'goals',
        "products": [
          {
            'silica-kids': 1000
          },
          {
            'k2-vital-delta-kids': 1000
          }
        ]
      },
      {
        "label": 'Better immunity',
        "icon": 'immunity',
        "questionId": 'goals',
        "products": [
          {
            'beta-glucan-kids': 1000
          },
          {
            'lactospore-probiotic-kids': 1000
          }
        ]
      },
      {
        "label": 'Better focus & memory',
        "icon": 'focus',
        "questionId": 'goals',
        "products": [
          {
            'lactospore-probiotic-kids': 1000
          },
          {
            'maca-powder-kids': 1000
          }
        ]
      },
      {
        "label": 'Improve skin, hair, nails & acne',
        "icon": "face",
        "questionId": 'goals',
        "products": [
          {
            'silica-kids': 1000
          },
          {
            'selenium-kids': 1000
          },
          {
            'hydrocurc-pepperine-kids': 1000
          },
          {
            'scutellup-kids': 1000
          }
        ]
      },
      {
        "label": 'Protect eyes from screen exposure',
        "icon": "eye",
        "questionId": 'goals',
        "products": [
          {
            'tart-cherry-kids': 1000
          },
          {
            'maca-powder-kids': 1000
          }
        ]
      },
      {
        "label": 'Better stress management & mental wellbeing',
        "icon": "smile",
        "questionId": 'goals',
        "products": [
          {
            'hydrocurc-pepperine-kids': 5000
          },
          {
            'scutellup-kids': 5000
          }
        ]
      },
      {
        "label": 'Improve gut health',
        "icon": "gut",
        "questionId": 'goals',
        "products": [
          {
            'lactospore-probiotic-kids': 1000
          },
          {
            'ginger-kids': 1000
          },
          {
            'hydrocurc-pepperine-kids': 500
          },
          {
            'scutellup-kids': 500
          }
        ]
      },
      {
        "label": 'Get more fruit & veg',
        "icon": "fruit",
        "questionId": 'goals',
        "products": [
          {
            'beetroot-kids': 1500
          },
          {
            'lycopene-kids': 1500
          }
        ]
      },
      {
        "label": 'Maintain active lifestyle',
        "icon": "shoe",
        "questionId": 'goals',
        "products": [
          {
            'silica-kids': 1000
          },
          {
            'k2-vital-delta-kids': 1000
          }
        ]
      }
    ]
  };

  const dietsQuestion = {
    "question": "Which diet?",
    "subText": "Either by choice or becuase of allergies",
    "answers": [
      {
        "label": 'Vegetarian',
        "questionId": 'diet',
        "products": [
          {
            "lactospore-probiotic-kids": 500
          },
          {
            "k2-vital-delta-kids": 500
          }
        ]
      },
      {
        "label": "Vegan",
        "questionId": "diet",
        "products": [
          {
            "lactospore-probiotic-kids": 1000
          },
          {
            "k2-vital-delta-kids": 1000
          }
        ]
      },
      {
        "label": "Pescatarian",
        "questionId": "diet",
      },
      {
        "label": "Dairy free",
        "questionId": "diet",
      },
      {
        "label": "Gluten free",
        "questionId": "diet",
      },
      {
        "label": "Nut free",
        "questionId": "diet",
      },
      {
        "label": "Reducetarian",
        "questionId": "diet",
      }
    ]
  };

  const conditionsQuestion = {
    "question": "Does your child suffer from any of the below?",
    "answers": [
      {
        "label": "Asthma",
        "questionId": "conditions",
        "products": [
          {
            'beta-glucan-kids': 500
          },
          {
            'lactospore-probiotic-kids': 500
          }
        ]
      },
      {
        "label": "Hayfever",
        "questionId": "conditions",
        "products": [
          {
            'beta-glucan-kids': 500
          },
          {
            'lactospore-probiotic-kids': 500
          }
        ]
      },
      {
        "label": "Frequent colds or flus",
        "questionId": "conditions",
        "products": [
          {
            'beta-glucan-kids': 1500
          },
          {
            'lactospore-probiotic-kids': 1500
          }
        ]
      },
      {
        "label": "Growing Pains",
        "questionId": "conditions",
        "products": [
          {
            'silica-kids': 500
          },
          {
            'k2-vital-delta-kids': 500
          }
        ]
      },
      {
        "label": "Hyperactivity or lack of focus",
        "questionId": "conditions",
        "products": [
          {
            'lactospore-probiotic-kids': 500
          },
          {
            'maca-powder-kids': 500
          }
        ]
      },
      {
        "label": "Crohn's Disease",
        "questionId": "conditions",
        "products": [
          {
            'lactospore-probiotic-kids': 500
          },
          {
            'ginger-kids': 500
          }
        ]
      },
      {
        "label": "IBS",
        "questionId": "conditions",
        "products": [
          {
            'lactospore-probiotic-kids': 500
          },
          {
            'ginger-kids': 500
          }
        ]
      },
      {
        "label": "Headaches",
        "questionId": "conditions",
        "products": [
          {
            'silica-kids': 500
          },
          {
            'k2-vital-delta-kids': 500
          }
        ]
      },
      {
        "label": "ADHD",
        "questionId": "conditions",
        "products": [
          {
            'lactospore-probiotic-kids': 500
          },
          {
            'maca-powder-kids': 500
          },
          {
            'hydrocurc-pepperine-kids': 2000
          },
          {
            'scutellup-kids': 2000
          }
        ]
      },
      {
        "label": "Coeliac Disease",
        "questionId": "conditions",
        "products": [
          {
            'lactospore-probiotic-kids': 500
          },
          {
            'ginger-kids': 500
          }
        ]
      },
      {
        "label": "Acne or Skin Complaints ",
        "questionId": "conditions",
        "products": [
          {
            'silica-kids': 500
          },
          {
            'selenium-kids': 500
          },
          {
            'hydrocurc-pepperine-kids': 500
          },
          {
            'scutellup-kids': 500
          }
        ]
      },
      {
        "label": "Migraines",
        "questionId": "conditions",
        "products": [
          {
            'lactospore-probiotic-kids': 500
          },
          {
            'maca-powder-kids': 500
          }
        ]
      },
      {
        "label": "Stomach or Digestion Issues",
        "questionId": "conditions",
        "products": [
          {
            'lactospore-probiotic-kids': 500
          },
          {
            'ginger-kids': 500
          }
        ]
      },
      {
        "label": "None",
        "questionId": "conditions",
        "products": []
      },
    ]
  };

  const renderGenderAnswers = genderAnswers.map((answer) => {
    return (
      <button
        key={answer.value}
        className={`answer-button ${gender === answer.value ? 'answer-button--active' : ''}`}
        name={answer.name}
        onClick={() => updateGender(answer.value)}
      >
        {answer.label}
      </button>
    );
  });

  const updateKidsName = (answer) => {
    setKidsName(answer);
    updateQuestionUrl('kids-name');
  }

  const updateGender = (answer) => {
    setGender(answer);
    updateQuestionUrl('gender');
  }

  const updateParentsName = (answer) => {
    setParentsName(answer);
    updateQuestionUrl('parents-name');
  }

  const onChangeNumber = (e) => {
    const re = /^[0-9\b]+$/;
    // make sure that only numbers can be input into the age field
    if (e.target.value === '' || re.test(e.target.value)) {
      setAge(e.target.value);
    }
    updateQuestionUrl('age');
  };

  const checkAge = () => {
    if (age && (age > 17 || age < 4)) {
      setSuitableAge(false);
    } else {
      setSuitableAge(true);
    }
  };

  const ageWarningMessage = () => {
    if (!suitableAge && age > 17) {
      return (
        <>
          <p>Your child is old enough to take the adult quiz, please click the button below to proceed</p>
          <a href="/pages/quiz" class="next-page">Adult Quiz</a>
        </>
      );
    } else if (!suitableAge && age < 4) {
      return <p>Sorry, nourished kids is not suitable for children under 4 years old</p>;
    } else {
      return;
    }
  };

  const renderGoalAnswers = goalsQuestion.answers.map((answer, index) => {
    return (
      <div
        key={index}
        className={`answer-button answer-button__icon ${activeGoalsAnswer === index ? 'answer-button--active' : ''}`}
        onClick={e => logAnswers(answer, index, answer.questionId)}
      >
        {answer.icon === 'energy' ? <Energy /> : ''}
        {answer.icon === 'immunity' ? <Immunity /> : ''}
        {answer.icon === 'focus' ? <Focus /> : ''}
        {answer.icon === 'face' ? <Face /> : ''}
        {answer.icon === 'eye' ? <Eye /> : ''}
        {answer.icon === 'smile' ? <Smile /> : ''}
        {answer.icon === 'gut' ? <Gut /> : ''}
        {answer.icon === 'fruit' ? <Fruit /> : ''}
        {answer.icon === 'shoe' ? <Shoe /> : ''}

        {answer.label}
      </div>
    );
  });

  const logAnswers = (answer, index, questionId) => {
    updateQuestionUrl('goals');
    if (activeGoalsAnswer === index) {
      setActiveGoalsAnswer([]);
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        [questionId]: {}
      }));
    } else {
      setActiveGoalsAnswer(index);
      if (answer.products !== undefined) {
        setWeightingsAnswers(prevWeightings => ({
          ...prevWeightings,
          [questionId]: answer
        }));
      }
    }
  };

  const logMultipleAnswers = (answer, index, questionId) => {
    updateQuestionUrl('dietSelection');
    // If answer is already selected...
    if (dietAnswersIndex.indexOf(index) !== -1) {
      // remove it from the index tracker
      const newDietAnswersIndex = dietAnswersIndex.filter(item => item !== index);
      setDietAnswersIndex(newDietAnswersIndex);
      //remove the weighting
      let weightingsToKeep = [];
      weightingAnswers[questionId].forEach(element => {
        if (element.label !== index) {
          weightingsToKeep.push(element);
        }
      });
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        [questionId]: weightingsToKeep
      }));
    } else {
      setDietAnswersIndex(prevAnswers => ([
        ...prevAnswers,
        index
      ]));
      if (answer.products !== undefined) {
        if (weightingAnswers[questionId] && weightingAnswers[questionId].length > 0) {
          const updatedAnswer = [...weightingAnswers[questionId], answer];
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            [questionId]: updatedAnswer
          }));
        } else {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            [questionId]: [answer]
          }));
        }
      }
    }
  };

  const logMultipleConditionsAnswers = (answer, index, questionId) => {
    updateQuestionUrl('conditions');
    // If answer is already selected...
    if (conditionsAnswerIndex.indexOf(index) !== -1) {
      // remove it from the index tracker
      const newConditionsAnswerIndex = conditionsAnswerIndex.filter(item => item !== index);
      setConditionsAnswerIndex(newConditionsAnswerIndex);
      //remove the weighting
      let weightingsToKeep = [];
      weightingAnswers[questionId].forEach(element => {
        if (element.label !== index) {
          weightingsToKeep.push(element);
        }
      });
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        [questionId]: weightingsToKeep
      }));
    } else if (index === 'None') {
      setConditionsAnswerIndex([index]);
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        [questionId]: {}
      }));
    } else {
      setConditionsAnswerIndex(prevAnswers => {
        let newAnswers = prevAnswers;
        if (prevAnswers.indexOf('None') !== -1) {
          newAnswers = newAnswers.filter(item => item !== 'None');
        }
        return ([...newAnswers, index]);
      });
      if (answer.products !== undefined) {
        if (weightingAnswers[questionId] && weightingAnswers[questionId].length > 0) {
          const updatedAnswer = [...weightingAnswers[questionId], answer];
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            [questionId]: updatedAnswer
          }));
        } else {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            [questionId]: [answer]
          }));
        }
      }
    }
  };

  const logHungryAnswer = (event) => {
    updateQuestionUrl('hungry');
    const radioValue = event.target.value;

    if (radioValue === 'yes') {
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        "hungry": {
          "products": [
            {
              "beetroot-kids": 500
            },
            {
              "lycopene-kids": 500
            }
          ]
        }
      }))
      setHungryBetweenMeals('yes');
    } else {
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        "hungry": {}
      }));
      setHungryBetweenMeals('no');
    }
  };

  const logGlassesAnswer = (event) => {
    updateQuestionUrl('glasses');
    const radioValue = event.target.value;

    if (radioValue === 'yes') {
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        "glasses": {
          "products": [
            {
              'tart-cherry-kids': 1000
            },
            {
              'maca-powder-kids': 1000
            }
          ]
        }
      }))
      setGlassesAnswer(radioValue);
    } else {
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        "glasses": {}
      }));
      setGlassesAnswer(radioValue);
    }
  };

  const onSpecificDietClick = (event) => {
    updateQuestionUrl('specificDiet');
    if (event.target.value === 'no') {
      setDietAnswersIndex([]);
      setWeightingsAnswers(prevWeightings => ({
        ...prevWeightings,
        'diet': []
      }));
      setSpecificDiet('no');
    } else {
      setSpecificDiet('yes');
    }
  }

  const renderDietAnswers = dietsQuestion.answers.map((answer) => {
    return (
      <div
        key={answer.label}
        className={`answer-button ${dietAnswersIndex.indexOf(answer.label) !== -1 ? 'answer-button--active' : ''}`}
        onClick={e => logMultipleAnswers(answer, answer.label, answer.questionId)}
      >
        {answer.label}
      </div>
    );
  });

  const renderConditionsAnswers = conditionsQuestion.answers.map((answer) => {
    return (
      <div
        key={answer.label}
        className={`answer-button ${conditionsAnswerIndex.indexOf(answer.label) !== -1 ? 'answer-button--active' : ''}`}
        onClick={e => logMultipleConditionsAnswers(answer, answer.label, answer.questionId)}
      >
        {answer.label}
      </div>
    );
  });

  const handleFoodRadios = (e) => {
    updateQuestionUrl('foodRadio');
    switch (e.target.id) {
      case 'processedFoodRarely':
        setWeightingsAnswers(prevWeightings => ({
          ...prevWeightings,
          "processedFood": {}
        }));
        setProcessedFoodAnswer(e.target.id);
        break;
      case 'processedFood12':
        setWeightingsAnswers(prevWeightings => ({
          ...prevWeightings,
          "processedFood": {}
        }));
        setProcessedFoodAnswer(e.target.id);
        break;
      case 'processedFood34':
        setWeightingsAnswers(prevWeightings => ({
          ...prevWeightings,
          "processedFood": {
            "products": [
              {
                'beetroot-kids': 500
              },
              {
                'lycopene-kids': 500
              }
            ]
          }
        }));
        setProcessedFoodAnswer(e.target.id);
        break;
      case 'processedFood5':
        setWeightingsAnswers(prevWeightings => ({
          ...prevWeightings,
          "processedFood": {
            "products": [
              {
                'beetroot-kids': 1000
              },
              {
                'lycopene-kids': 1000
              }
            ]
          }
        }));
        setProcessedFoodAnswer(e.target.id);
        break;
      case 'fruitVegRarely':
        setWeightingsAnswers(prevWeightings => ({
          ...prevWeightings,
          "fruitVeg": {
            "products": [
              {
                'beetroot-kids': 1500
              },
              {
                'lycopene-kids': 1500
              }
            ]
          }
        }));
        setFruitVegAnswer(e.target.id);
        break;
      case 'fruitVeg12':
        setWeightingsAnswers(prevWeightings => ({
          ...prevWeightings,
          "fruitVeg": {
            "products": [
              {
                'beetroot-kids': 500
              },
              {
                'lycopene-kids': 500
              }
            ]
          }
        }));
        setFruitVegAnswer(e.target.id);
        break;
      case 'fruitVeg34':
        setWeightingsAnswers(prevWeightings => ({
          ...prevWeightings,
          "fruitVeg": {
            "products": [
              {
                'beetroot-kids': 500
              },
              {
                'lycopene-kids': 500
              }
            ]
          }
        }));
        setFruitVegAnswer(e.target.id);
        break;
      case 'fruitVeg5':
        setWeightingsAnswers(prevWeightings => ({
          ...prevWeightings,
          "fruitVeg": {}
        }));
        setFruitVegAnswer(e.target.id);
        break;
      default:
        break;
    }
  }

  const handleSlider = (value, sliderId) => {
    const sliderValue = value;

    switch (sliderId) {
      case 'energy':
        updateQuestionUrl('energy');
        setEnergySliderValue(sliderValue);
        if (sliderValue < 34) {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "energySlider": {
              "products": [
                {
                  'silica-kids': 1500
                },
                {
                  'k2-vital-delta-kids': 1500
                }
              ]
            }
          }));
        } else if (sliderValue < 67) {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "energySlider": {
              "products": [
                {
                  'silica-kids': 1000
                },
                {
                  'k2-vital-delta-kids': 1000
                },
                {
                  'lactospore-probiotic-kids': 1000
                },
                {
                  'maca-powder-kids': 1000
                }
              ]
            }
          }));
        } else {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "energySlider": {}
          }));
        }
        break;

      case 'activity':
        updateQuestionUrl('activity');
        setActivitySliderValue(sliderValue);
        if (sliderValue < 34) {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "activitySlider": {
              "products": [
                {
                  'silica-kids': 500
                },
                {
                  'k2-vital-delta-kids': 500
                }
              ]
            }
          }));
        } else if (sliderValue < 67) {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "activitySlider": {
              "products": [
                {
                  'silica-kids': 1000
                },
                {
                  'k2-vital-delta-kids': 1000
                }
              ]
            }
          }));
        } else {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "activitySlider": {
              "products": [
                {
                  'silica-kids': 1500
                },
                {
                  'k2-vital-delta-kids': 1500
                }
              ]
            }
          }));
        }
        break;

      case 'sleep':
        updateQuestionUrl('sleep');
        setSleepSliderValue(sliderValue);
        break;

      case 'screen':
        updateQuestionUrl('screen');
        setScreenSliderValue(sliderValue);
        if (sliderValue < 34) {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "screenSlider": {
              "products": [
                {
                  'tart-cherry-kids': 500
                },
                {
                  'maca-powder-kids': 500
                }
              ]
            }
          }));
        } else if (sliderValue < 67) {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "screenSlider": {
              "products": [
                {
                  'tart-cherry-kids': 1000
                },
                {
                  'maca-powder-kids': 1000
                }
              ]
            }
          }));
        } else {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "screenSlider": {
              "products": [
                {
                  'tart-cherry-kids': 1500
                },
                {
                  'maca-powder-kids': 1500
                }
              ]
            }
          }));
        }
        break;

      case 'attention':
        updateQuestionUrl('attention');
        setAttentionSliderValue(sliderValue);
        if (sliderValue < 34) {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "attentionSlider": {
              "products": [
                {
                  'lactospore-probiotic-kids': 1500
                },
                {
                  'maca-powder-kids': 1500
                },
                {
                  'hydrocurc-pepperine-kids': 2000
                },
                {
                  'scutellup-kids': 2000
                }
              ]
            }
          }));
        } else if (sliderValue < 67) {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "attentionSlider": {
              "products": [
                {
                  'lactospore-probiotic-kids': 1000
                },
                {
                  'maca-powder-kids': 1000
                },
                {
                  'hydrocurc-pepperine-kids': 1000
                },
                {
                  'scutellup-kids': 1000
                }
              ]
            }
          }));
        } else {
          setWeightingsAnswers(prevWeightings => ({
            ...prevWeightings,
            "attentionSlider": {}
          }));
        }
        break;
      default:
        break;
    }
  }

  const selectFlavour = (e) => {
    updateQuestionUrl('flavour');
    setFlavour(e.target.value);
  }

  const selectCoating = (e) => {
    updateQuestionUrl('coating');
    setCoating(e.target.value);
  }

  const calculateWeights = async () => {
    let weights = {};

    const addToWeighting = (product, weighting) => {
      weights[product]
        ? weights[product] += weighting
        : weights[product] = weighting;
    }

    (function retrieveWeights(obj) {
      for (const [key, value] of Object.entries(obj)) {
        switch (key) {
          case 'silica-kids':
            addToWeighting(key, value);
            break;
          case 'k2-vital-delta-kids':
            addToWeighting(key, value);
            break;
          case 'lactospore-probiotic-kids':
            addToWeighting(key, value);
            break;

          case 'maca-powder-kids':
            addToWeighting(key, value);
            break;

          case 'ginger-kids':
            addToWeighting(key, value);
            break;

          case 'beetroot-kids':
            addToWeighting(key, value);
            break;

          case 'lycopene-kids':
            addToWeighting(key, value);
            break;

          case 'beta-glucan-kids':
            addToWeighting(key, value);
            break;

          case 'tart-cherry-kids':
            addToWeighting(key, value);
            break;

          case 'selenium-kids':
            addToWeighting(key, value);
            break;

          case 'hydrocurc-pepperine-kids':
            addToWeighting(key, value);
            break;

          case 'scutellup-kids':
            addToWeighting(key, value);
            break;

          default:
            break;
        }

        if (typeof value === 'object') {
          retrieveWeights(value);
        }
      }
    }(weightingAnswers));

    function findTopTwo(obj) {
      return Object.keys(obj).sort((a, b) => { return obj[b] - obj[a] }).slice(0, 2);
    }

    const kidsCoreBlends4 = ['vitamin-c-kids-4', 'coq10-b12-kids-4', 'folic-acid-vitamin-d3-kids-4', 'iron-zinc-kids-4', 'vitamin-a-vitamin-e-kids-4'];
    const kidsCoreBlendSplit4 = ['vitamin-c-kids-4', 'coq10-kids-4', 'b12-kids-4', 'folic-acid-kids-4', 'vitamin-d3-kids-4', 'iron-kids-4', 'zinc-kids-4', 'vitamin-a-kids-4', 'vitamin-e-kids-4'];
    const kidsCoreBlends9 = ['vitamin-c-kids-9', 'coq10-b12-kids-9', 'folic-acid-vitamin-d3-kids-9', 'iron-zinc-kids-9', 'vitamin-a-vitamin-e-kids-9'];
    const kidsCoreBlendSplit9 = ['vitamin-c-kids-9', 'coq10-kids-9', 'b12-kids-9', 'folic-acid-kids-9', 'vitamin-d3-kids-9', 'iron-kids-9', 'zinc-kids-9', 'vitamin-a-kids-9', 'vitamin-e-kids-9'];
    let suggestedInclusions = findTopTwo(weights);

    const checkedSuggestedInclusions = suggestedInclusions.map(handle => {
      if (handle === 'k2-vital-delta-kids') {
        if (age < 9) {
          return `${handle}-4`;
        } else {
          return `${handle}-9`;
        }
      } else {
        return handle;
      }
    });

    let selectedDiets = '';
    let resultsHandles = [];
    let allHandles = [];

    if (age < 9) {
      resultsHandles = kidsCoreBlends4.concat(checkedSuggestedInclusions);
      allHandles = kidsCoreBlendSplit4.concat(checkedSuggestedInclusions);
    } else {
      resultsHandles = kidsCoreBlends9.concat(checkedSuggestedInclusions);
      allHandles = kidsCoreBlendSplit9.concat(checkedSuggestedInclusions);
    }

    if (dietAnswersIndex.length > 0) {
      selectedDiets = dietAnswersIndex.join(', ');
    }

    const resultsForKlaviyo = resultsHandles.join(', ');

    let payload = {
      parentsName,
      kidsName,
      priority: weightingAnswers.goals.label,
      age,
      gender,
      selectedDiets,
      flavour,
      coating,
      handles: resultsHandles,
      allHandles,
      quizID: quizID,
    }
    // console.log(JSON.stringify(payload));
    // console.log(payload);

    if (email !== '' && consent) {
      await klaviyoData(resultsForKlaviyo);
    }

    // Record quiz amount in session and local storage
    let quizSession;
    let quizLocal;

    let currentSessionCount = sessionStorage.getItem('quizSession');
    let currentLocalCount = localStorage.getItem('quizLocal');

    if (currentSessionCount) {
      quizSession = parseInt(currentSessionCount) + 1;
      sessionStorage.setItem('quizSession', quizSession);
    } else {
      quizSession = 1;
      sessionStorage.setItem('quizSession', quizSession);
    }

    if (currentLocalCount) {
      quizLocal = parseInt(currentLocalCount) + 1;
      localStorage.setItem('quizLocal', quizLocal);
    } else {
      quizLocal = 1;
      localStorage.setItem('quizLocal', quizLocal);
    }

    let goal = 'None';
    switch(activeGoalsAnswer){
      case(0):
        goal = 'More Energy';
        break;
      case(1):
        goal = 'Better Immunity';
        break;
      case(2):
        goal = 'Better Focus & memory';
        break;
      case(3):
        goal = 'Improve skin, hair, nails';
        break;
      case(4):
        goal = 'Protect eyes from screens';
        break;
      case(5):
        goal = 'Better stress management';
        break;
      case(6):
        goal = 'Improve gut health';
        break;
      case(7):
        goal = 'Get more fruit & veg';
        break;
      case(8):
        goal = 'Maintain active lifestyle';
        break;
    }
      
    const dataToSend = {
      "1": `${gender}`,
      "2": `${age}`,
      "3": `${energySliderValue}`,
      "4": `${activitySliderValue}`,
      "5": `${sleepSliderValue}`,
      "6": `${screenSliderValue}`,
      "7": `${specificDiet}`,
      "8": `${dietAnswersIndex}`,
      "9": `${hungryBetweenMeals}`,
      "10": `${processedFoodAnswer}`,
      "11": `${fruitVegAnswer}`,
      "12": `${glassesAnswer}`,
      "13": `${conditionsAnswerIndex}`,
      "14": `${goal}`,
      "15": `${flavour}`,
      "16": `${coating}`,
      "17": `${consent}`,
      "18": `${resultsHandles[0]}`,
      "19": `${resultsHandles[1]}`,
      "20": `${resultsHandles[2]}`,
      "21": `${resultsHandles[3]}`,
      "22": `${resultsHandles[4]}`,
      "23": `${resultsHandles[5]}`,
      "24": `${resultsHandles[6]}`,
      "25": `${new Date().toLocaleString('en-GB')}`,
      "26": `${Date.now()}`,
      "27": `${quizSession}`,
      "28": `${quizLocal}`,
      "29": `${quizID}`,
    }

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000);

    // Send data to google sheets
    // avoid test data
    if (kidsName !== 'Test') {
      fetch(`https://script.google.com/macros/s/AKfycbwrbTvzJP3_d38XVOI4ft3I5Zii6bhHDV0ESbmbsYmwbkbbkOP0Ltx1NvIwwkWZ8mOo/exec`, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(dataToSend),
        signal: controller.signal
      })
        .then(function (res) {
          window.localStorage.setItem('kids-quiz-results', JSON.stringify(payload));
          window.location = '/pages/kids-results';
        })
        .catch(function (err) {
          window.localStorage.setItem('kids-quiz-results', JSON.stringify(payload));
          window.location = '/pages/kids-results';
        });
    } else {
      window.localStorage.setItem('kids-quiz-results', JSON.stringify(payload));
      window.location = '/pages/kids-results';
    }
  }

  const validatePageOne = () => {
    let errorMessage = '';

    if (kidsName === '') {
      errorMessage += 'Please enter a value for your childs name';
    } else if (gender === '') {
      errorMessage += 'Please select a gender option';
    } else if (age === '') {
      errorMessage += 'Please enter your childs age';
    } else if (!suitableAge) {
      errorMessage += 'Please check the childs age you entered';
    }

    if (errorMessage) {
      alert(errorMessage);
    } else {
      return true;
    }
  }

  const validatePageTwo = () => {
    if (activeGoalsAnswer.length < 1) {
      alert('Please select a goal');
    } else {
      return true;
    }
  }

  const validatePageThree = () => {
    let errorMessage = '';

    if (!specificDiet) {
      errorMessage += `Let us know if ${kidsName} follow a specific diet`;
    } else if (!hungryBetweenMeals) {
      errorMessage += `Let us know if ${kidsName} gets hungry between meals`;
    } else if (!processedFoodAnswer) {
      errorMessage += `Please tell us how often ${kidsName} eats processed food a week`;
    } else if (!fruitVegAnswer) {
      errorMessage += `Please tell us how often ${kidsName} eats fruit & veg a week`;
    }

    if (errorMessage) {
      alert(errorMessage);
    } else {
      return true;
    }
  }

  const validatePageFive = () => {
    if (!glassesAnswer) {
      alert(`Please tell us if ${kidsName} wears glasses or contact lenses`);
    } else {
      return true;
    }
  }

  const validatePageSix = () => {
    if (!flavour || !coating) {
      alert(`Please select a flavour for ${kidsName}'s stacks`);
    } else {
      return true;
    }
  }

  const klaviyoData = (resultsInclusions) => {
    return new Promise((resolve, reject) => {
      let selectedDiets = 'non selected';
      let healthConditions = 'non selected';
      let handlesString = 'Error in handles';
      let dietsNumbers = [];
      let handlesNumbers = [];
      let kidsResultsLink = '?';

      // if (conditionsAnswerIndex.length > 0) {
      //   healthConditions = conditionsAnswerIndex.join(', ');
      // }

      if (dietAnswersIndex.length > 0) {
        selectedDiets = dietAnswersIndex.join(', ');

        dietAnswersIndex.forEach(diet => {
          switch (diet) {
            case 'Vegetarian':
              dietsNumbers.push('1');
              break;
            case 'Vegan':
              dietsNumbers.push('2');
              break;
            case 'Pescatarian':
              dietsNumbers.push('3');
              break;
            case 'Dairy free':
              dietsNumbers.push('4');
              break;
            case 'Gluten free':
              dietsNumbers.push('5');
              break;
            case 'Nut free':
              dietsNumbers.push('6');
              break;
            case 'Reducetarian':
              dietsNumbers.push('7');
              break;
            default:
              break;
          }
        })
      }

      if (resultsInclusions.length > 0) {
        handlesString = resultsInclusions.split(', ');

        handlesString.forEach(handle => {
          switch (handle) {
            case 'silica-kids':
              handlesNumbers.push('1');
              break;
            case 'k2-vital-delta-kids':
              handlesNumbers.push('2');
              break;
            case 'lactospore-probiotic-kids':
              handlesNumbers.push('3');
              break;
            case 'maca-powder-kids':
              handlesNumbers.push('4');
              break;
            case 'ginger-kids':
              handlesNumbers.push('5');
              break;
            case 'beetroot-kids':
              handlesNumbers.push('6');
              break;
            case 'lycopene-kids':
              handlesNumbers.push('7');
              break;
            case 'beta-glucan-kids':
              handlesNumbers.push('8');
              break;
            case 'tart-cherry-kids':
              handlesNumbers.push('9');
              break;
            case 'selenium-kids':
              handlesNumbers.push('10');
              break;
            case 'hydrocurc-pepperine-kids':
              handlesNumbers.push('11');
              break;
            case 'scutellup-kids':
              handlesNumbers.push('12');
              break;
            default:
              break;
          }
        });
      }

      kidsResultsLink += `pn=${parentsName}`;
      kidsResultsLink += `&fe=${kidsName}`;
      kidsResultsLink += `&priority=${activeGoalsAnswer}`;
      kidsResultsLink += `&ae=${age}`;
      kidsResultsLink += `&ge=${gender}`;
      kidsResultsLink += `&selectedDiets=${dietsNumbers.join(',')}`;
      kidsResultsLink += `&flavour=${flavour}`;
      kidsResultsLink += `&coating=${coating}`;
      kidsResultsLink += `&handles=${handlesNumbers}`;
      kidsResultsLink += `&quizid=${quizID}`

      const responses = {
        "responses": [
          {
            "question": "NK: Childs name",
            "answers": `${kidsName}`
          },
          {
            "question": "NK: Childs gender",
            "answers": `${gender}`
          },
          {
            "question": "NK: Childs age",
            "answers": `${age}`
          },
          {
            "question": "NK: Kids goal",
            "answers": `${weightingAnswers.goals.label}`
          },
          {
            "question": "NK: Specific diet?",
            "answers": `${specificDiet}`
          },
          {
            "question": "NK: Selected diets",
            "answers": `${selectedDiets}`
          },
          {
            "question": "NK: Hungry between meals?",
            "answers": `${hungryBetweenMeals}`
          },
          {
            "question": "NK: Processes food frequency:",
            "answers": `${processedFoodAnswer}`
          },
          {
            "question": "NK: Fruit & Veg frequency:",
            "answers": `${fruitVegAnswer}`
          },
          {
            "question": "NK: Energy slider value:",
            "answers": `${energySliderValue}`
          },
          {
            "question": "NK: Activity slider value:",
            "answers": `${activitySliderValue}`
          },
          {
            "question": "NK: Sleep slider value:",
            "answers": `${sleepSliderValue}`
          },
          {
            "question": "NK: Screen slider value:",
            "answers": `${screenSliderValue}`
          },
          {
            "question": "NK: Attention slider value:",
            "answers": `${attentionSliderValue}`
          },
          {
            "question": "NK: Health conditions:",
            "answers": `${healthConditions}`
          },
          {
            "question": "NK: Wear glasses or contacts?",
            "answers": `${glassesAnswer}`
          },
          {
            "question": "NK: Flavour:",
            "answers": `${flavour}`
          },
          {
            "question": "NK: Coating",
            "answers": `${coating}`
          },
          {
            "question": "NK: Parents name",
            "answers": `${parentsName}`
          },
          {
            "question": "NK: Results",
            "answers": `${resultsInclusions}`
          },
          {
            "question": "NK: Results link",
            "answers": `${kidsResultsLink}`
          }
        ]
      };

      const cusomerData = { email: email }

      let submittedPayload = [];
      submittedPayload.push(cusomerData, responses);

      if (email !== '') {
        fetch(apiQuizKids, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(submittedPayload),
        })
          .then(function (res) {
            resolve(res);
          })
          .catch(function (error) {
            reject(error);
          });
      }
    });
  }

  const nextPage = (continueIndex) => {
    let quizRoot = document.getElementById('root');
    quizRoot.scrollIntoView();

    switch (continueIndex) {
      case '1':
        if (validatePageOne() === true) {
          setPageIndex(pageIndex + 1);
          setQuizID('K-'+Math.floor(Date.now() + Math.random() * 100));
        }
        break;
      case '2':
        if (validatePageTwo() === true) {
          setPageIndex(pageIndex + 1);
        }
        break;
      case '3':
        if (validatePageThree() === true) {
          setPageIndex(pageIndex + 1);
        }
        break;
      case '4':
        setPageIndex(pageIndex + 1);
        break;
      case '5':
        if (validatePageFive() === true) {
          setPageIndex(pageIndex + 1);
        }
        break;
      case '6':
        if (validatePageSix() === true) {
          calculateWeights(weightingAnswers);
        }
        break;
      default:
        break;
    }

  }

  const backPage = () => {
    let quizRoot = document.getElementById('root');
    quizRoot.scrollIntoView();
    if (pageIndex > 1) {
      setPageIndex(pageIndex - 1);
    }
  }

  return (
    <div className="kids-quiz">
      <Header pageIndex={pageIndex} backPage={backPage} />

      <TransitionGroup>
        <CSSTransition
          key={pageIndex}
          in={true}
          appear={true}
          timeout={1000}
          classNames="slide"
        >
          <>
            {{
              1: (
                <PageOne
                  kidsName={kidsName}
                  updateKidsName={updateKidsName}
                  renderGenderAnswers={renderGenderAnswers}
                  gender={gender}
                  onChangeNumber={onChangeNumber}
                  checkAge={checkAge}
                  age={age}
                  ageWarningMessage={ageWarningMessage}
                  nextPage={nextPage}
                  suitableAge={suitableAge}
                />
              ),
              2: (
                <PageTwo
                  goalsQuestion={goalsQuestion}
                  renderGoalAnswers={renderGoalAnswers}
                  activeGoalsAnswer={activeGoalsAnswer}
                  nextPage={nextPage}
                />
              ),
              3: (
                <PageThree
                  kidsName={kidsName}
                  gender={gender}
                  onSpecificDietClick={onSpecificDietClick}
                  specificDiet={specificDiet}
                  renderDietAnswers={renderDietAnswers}
                  dietAnswersIndex={dietAnswersIndex}
                  logHungryAnswer={logHungryAnswer}
                  hungryBetweenMeals={hungryBetweenMeals}
                  handleFoodRadios={handleFoodRadios}
                  processedFoodAnswer={processedFoodAnswer}
                  fruitVegAnswer={fruitVegAnswer}
                  nextPage={nextPage}
                />
              ),
              4: (
                <PageFour
                  kidsName={kidsName}
                  energySliderValue={energySliderValue}
                  handleSlider={handleSlider}
                  activitySliderValue={activitySliderValue}
                  sleepSliderValue={sleepSliderValue}
                  screenSliderValue={screenSliderValue}
                  attentionSliderValue={attentionSliderValue}
                  nextPage={nextPage}
                />
              ),
              5: (
                <PageFive
                  kidsName={kidsName}
                  renderConditionsAnswers={renderConditionsAnswers}
                  gender={gender}
                  logGlassesAnswer={logGlassesAnswer}
                  glassesAnswer={glassesAnswer}
                  nextPage={nextPage}
                />
              ),
              6: (
                <PageSix
                  kidsName={kidsName}
                  gender={gender}
                  selectFlavour={selectFlavour}
                  flavour={flavour}
                  selectCoating={selectCoating}
                  coating={coating}
                  updateParentsName={updateParentsName}
                  parentsName={parentsName}
                  setEmail={setEmail}
                  email={email}
                  consent={consent}
                  setConsent={setConsent}
                  calculateWeights={calculateWeights}
                  weightingAnswers={weightingAnswers}
                  nextPage={nextPage}
                />
              )
            }[pageIndex]}
          </>
        </CSSTransition>
      </TransitionGroup>

    </div>
  );
};

export default KidsQuiz;